export type RedirectLocationContextType = {
  targetUrl: URL;
  includePath: boolean;
  includeQueryparams: boolean;
  currentPathname: string;
  currentSearch: string;
};

export type AppendTenantRedirectOptionsType = RedirectLocationContextType & {
  tenantId: string;
};

/**
 * Mutates `targetUrl` into the legacy tenant-login redirect format:
 * appends `/login`, forwards path/query via `postLoginRedirect` when
 * requested, and sets the `t1=<tenantId>` query param.
 */
export function appendTenantRedirect({
  targetUrl,
  tenantId,
  includePath,
  includeQueryparams,
  currentPathname,
  currentSearch
}: AppendTenantRedirectOptionsType): void {
  targetUrl.pathname = targetUrl.pathname.replace(/\/$/, '') + '/login';

  const postLoginRedirect =
    (includePath ? currentPathname : '') +
    (includeQueryparams ? currentSearch : '');
  if (postLoginRedirect) {
    targetUrl.searchParams.set('postLoginRedirect', postLoginRedirect);
  }

  targetUrl.searchParams.set('t1', tenantId);
}

/**
 * Mutates `targetUrl` by appending the current path and/or merging the
 * current query params directly onto it.
 */
export function appendCurrentLocation({
  targetUrl,
  includePath,
  includeQueryparams,
  currentPathname,
  currentSearch
}: RedirectLocationContextType): void {
  if (includePath) {
    targetUrl.pathname =
      targetUrl.pathname.replace(/\/$/, '') + currentPathname;
  }

  if (includeQueryparams) {
    new URLSearchParams(currentSearch).forEach((value, key) => {
      targetUrl.searchParams.set(key, value);
    });
  }
}
